import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { I18nProvider } from './lib/i18n';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import DashboardLayout from './components/layout/DashboardLayout';
import Dashboard from './pages/Dashboard';
import LoadBoard from './pages/LoadBoard';
import TruckBoard from './pages/TruckBoard';
import MyLoads from './pages/MyLoads';
import Insights from './pages/Insights';
import Documents from './pages/Documents';
import Payments from './pages/Payments';
import Subscription from './pages/Subscription';
import Profile from './pages/Profile';
import DriverApp from './pages/DriverApp';
import DriverLogin from './pages/DriverLogin';
import FleetMap from './pages/FleetMap';

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/driver" element={<DriverApp />} />
            <Route path="/driver/login" element={<DriverLogin />} />
            <Route path="/app" element={<DashboardLayout />}>
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="loads" element={<LoadBoard />} />
              <Route path="trucks" element={<TruckBoard />} />
              <Route path="fleet-map" element={<FleetMap />} />
              <Route path="my-loads" element={<MyLoads />} />
              <Route path="insights" element={<Insights />} />
              <Route path="documents" element={<Documents />} />
              <Route path="payments" element={<Payments />} />
              <Route path="subscription" element={<Subscription />} />
              <Route path="profile" element={<Profile />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </I18nProvider>
  );
}

export default App;
